import { Component, inject, Inject, OnDestroy, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogClose } from '@angular/material/dialog';

import { GoogleAnalyticsService } from '../../../core/services/google-analytics.service';
import { LanguageService } from '../../../core/services/language.service';
import { LastDeployedVersions } from '../../models/schemas/front-app-version.schema';
import { ModalSkelettonComponent } from '../modal-skeletton/modal-skeletton.component';
import { IconComponent } from '../../components/utils/icon/icon.component';
import { ButtonComponent } from '../../components/buttons/button/button.component';
import { SafePipe } from '../../pipes/safe.pipe';
import { EnvironmentService } from '../../../core/services/environment.service';

export interface ModalUpdateVersionData {
  forceUpdate: boolean;
  lastDeployedVersions: LastDeployedVersions | null;
}

@Component({
  selector: 'app-modal-update-version',
  templateUrl: './modal-update-version.component.html',
  imports: [ModalSkelettonComponent, IconComponent, ButtonComponent, MatDialogClose, SafePipe],
})
export class ModalUpdateVersionComponent implements OnInit, OnDestroy {
  public environmentService = inject(EnvironmentService);

  acceptUpdate = false;

  constructor(
    public dialogRef: MatDialogRef<ModalUpdateVersionComponent>,
    @Inject(MAT_DIALOG_DATA) public modalData: ModalUpdateVersionData,
    private googleAnalyticsService: GoogleAnalyticsService,
    public languageService: LanguageService
  ) {}

  ngOnInit() {}

  ngOnDestroy() {
    const acceptStr = this.acceptUpdate ? 'accept update site' : 'refuse update site';

    this.googleAnalyticsService.sendEvent(
      acceptStr,
      'update',
      'from ' +
        this.environmentService.stringifiedFrontAppVersion +
        ' to ' +
        (this.modalData.lastDeployedVersions
          ? this.modalData.lastDeployedVersions.lastVersion.name
          : '[auto]')
    );
  }

  updateSite() {
    // nnkitodo [v2later] je ne pense pas que ceci fonctionne
    this.acceptUpdate = true;
    window.location.href = window.location.href;
    window.location.reload();
  }

  close() {
    this.dialogRef.close();
  }
}
